// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".link-to-goal-task-label[data-v-3846a577]{cursor:pointer;font-size:16px}.remove-task-trash-icon[data-v-3846a577]{font-size:16px}\n", ""]);
// Exports
module.exports = exports;
